import 'babel-polyfill';
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import VueLazyLoad from 'vue-lazyload';
import 'common/js/validate';
import VueI18n from 'vue-i18n';
import clipboard from 'clipboard';
import zh from './common/lang/zh';
import en from './common/lang/en';
import 'default-passive-events'
import 'common/scss/index.scss';
// import VConsole from 'vconsole';
import './libs/rem.js'
import preventReClick from './assets/js/preventReClick'; //防多次点击，重复提交
import { List,Tab, Tabs, Dialog, Stepper,Button,PullRefresh,Toast,Sticky,Overlay  } from 'vant';
Vue.prototype.clipboard = clipboard;
Vue.use(List);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Dialog);
Vue.use(Stepper);
Vue.use(Button);
Vue.use(PullRefresh);
Vue.use(Toast);
Vue.use(Sticky);
Vue.use(Overlay);
Vue.use(preventReClick);

// const isDebug = true;
// if (isDebug) {
//   new VConsole();
// }
// 全局引入Toast
import toast from './base/toast/index';
Vue.use(toast);
Vue.use(VueLazyLoad, {
  loading: require('common/image/default.png')
});

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: localStorage.getItem("lang") || "zh",
  messages: {
    'zh': zh,
    'en': en
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js